import { type PriceItemType } from 'core/accounting/domain/PriceItemType'
import { type ShipmentContainer } from 'core/container-details/domain/ShipmentContainer'
import { type ManagedBy } from 'core/domain/ManagedBy'
import { type FullMode } from 'core/domain/Mode'
import { type Stop } from 'core/domain/Stop'
import { type TruckType } from 'core/domain/Truck'
import {
  type ShippingItem,
  type ShippingItemsMeasures,
} from 'core/shipping-items/domain/ShippingItem'
import { isPast } from 'core/utils/date'

import type { QuoteAccessorial } from './QuoteAccessorial'
import { type QuoteEquipmentRequirements } from './QuoteEquipmentRequirements'

export type Quote = {
  bidsDeadline: Date
  canReceiveProposals: boolean
  equipmentType: TruckType
  items: Array<ShippingItem>
  mileage?: number
  mode: FullMode
  notes?: string
  shipperGuideId: string
  shipperNotes?: string
  stops: Array<Stop>
  accessorials?: Array<QuoteAccessorial>
  requestedAccessorials: Array<PriceItemType>
  equipmentRequirements?: QuoteEquipmentRequirements
  measures?: ShippingItemsMeasures
  powerOnly?: boolean
  targetRate?: string
  managedBy?: ManagedBy
  container?: ShipmentContainer
}

export function isQuoteExpired({ bidsDeadline }: Quote): boolean {
  return isPast(bidsDeadline)
}

export function showAccessorials(quote: Quote) {
  return ['full_truck_load', 'less_than_truckload', 'partial_truckload', 'EXP'].includes(quote.mode)
}
